import Report from '@/components/reports';
import styled from 'styled-components';

const MainWrap = styled.div`
  width: 100%;
  height: 100%;
`;

export default function ReportTemplate() {
  return (
    <MainWrap>
      <Report />
    </MainWrap>
  );
}
